<div class="thp-form-container">
  <form [formGroup]="opportunitiesForm" class="thp-form">
    <label class="thp-header">{{"talent-happy-path.talent-profile.opportunities.title" | translate}}</label>
    <div class="field-group">
      <label class="field-label">{{"talent-happy-path.talent-profile.opportunities.new-opportunities" | translate}}</label>
      <mat-radio-group aria-labelledby="new-opportunity-radio-group-label" formControlName="activelySearchingSelected">
        <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
        <mat-radio-button [value]="false">{{"talent-happy-path.radio.no" | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="field-group">
      <label class="field-label">{{"talent-happy-path.talent-profile.opportunities.when-available" | translate}}</label>
      <mat-radio-group aria-labelledby="start-availability-radio-group-label" class="start-availability-radio-group" formControlName="availabilityType">
        <div class="availability-label">
          <mat-radio-button [value]="getAvailabilityType('now')" aria-labelledby="label-now"></mat-radio-button>
          <span id="label-now">{{"talent-happy-path.talent-profile.opportunities.availability-types.now" | translate}}</span>
        </div>
        <div class="availability-label">
          <mat-radio-button [value]="getAvailabilityType('specificDate')" aria-labelledby="label-specificDate"></mat-radio-button>
          <span id="label-specificDate">{{"talent-happy-path.talent-profile.opportunities.availability-types.date" | translate}}</span>
        </div>
        <div class="availability-label">
          <mat-radio-button [value]="getAvailabilityType('withNotice')" aria-labelledby="label-withNotice"></mat-radio-button>
          <span id="label-withNotice">{{"talent-happy-path.talent-profile.opportunities.availability-types.notice" | translate}}</span>
        </div>
      </mat-radio-group>
      <mat-form-field style="width: 100%" class="weeks-notice-input" *ngIf="availabilityType.value === talentProfileStartAvailability.WITH_NOTICE">
        <mat-label>{{"talent-happy-path.talent-profile.opportunities.availability-types.weeks-notice" | translate}}</mat-label>
        <input matInput type="text" formControlName="numWeeksNoticeNeeded">
      </mat-form-field>
      <app-date-picker *ngIf="availabilityType.value === talentProfileStartAvailability.SPECIFIC_DATE"
                      [(selectedDate)]="availabilityDate"
                       (selectedDateChange)="onAvailabilityDateChange($event)"
                       [personId]="this.talent.personId">
      </app-date-picker>
    </div>
    <div class="field-group">
      <label class="field-label">{{"talent-happy-path.talent-profile.opportunities.submit-other" | translate}}</label>
      <mat-radio-group aria-labelledby="other-positions-radio-group-label" class="new-opportunity-radio-group" formControlName="preAuthorizedSubmittal">
        <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
        <mat-radio-button [value]="false">{{"talent-happy-path.radio.check-later" | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </form>
  <div class="button-container">
    <button mat-button class="next-button" (click)="goToEmploymentPreferences()">{{"talent-happy-path.buttons.next" | translate}}</button>
    <button mat-button class="later-button" (click)="isModalVisible = true" *ngIf="!fromNotAFit">{{"talent-happy-path.buttons.do-later" | translate}}</button>
    <app-confirmation-modal
      [isVisible]="isModalVisible"
      (isVisibleChange)="isModalVisible = $event"
      header="{{'talent-happy-path.talent-profile.later-modal.header' | translate}}"
      description="{{'talent-happy-path.talent-profile.later-modal.description' | translate}}"
      (cancel)="isModalVisible = false"
      (confirm)="doThisLater(); isModalVisible = false">
    </app-confirmation-modal>
  </div>
</div>
